<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              Exibindo 2 NF de Entrada (Total de 2)
            </span>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">
              Acompanhe em tempo real todos as NFs de Entrada cadastradas pelo seu estabelecimento
            </span>
          </h3>
          <div class="card-toolbar">
            <div class="input-icon h-40px">
              <input
                type="text"
                class="form-control form-control-lg form-control-solid h-40px"
                v-model="buscar"
                placeholder="Buscar..."
              />
              <span>
                <span class="svg-icon svg-icon-lg">
                  <!--begin::Svg Icon-->
                  <inline-svg src="media/svg/icons/General/Search.svg" />
                  <!--end::Svg Icon-->
                </span>
              </span>
            </div>
          </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div
          @scroll="handleScroll"
          class="card-body pt-2 pb-0"
          style="max-height: 418px; overflow-y: auto; overflow-x: auto"
        >
          <!--begin::Table-->
          <div class="table-responsive" style="overflow-x: initial">
            <b-table striped hover :items="items" :fields="fields">
            </b-table>
          </div>
          <!--end::Table-->
        </div>
        <!--end::Body-->
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";

export default {
  name: "NFSEntrada",
  data() {
    return {
      buscar: "", // Emissão / Vencimento / NF Entrada / Serie / Emitente / Local de Estoque 
      items: [
        {
          EMISSAO: '21/02/2022',
          VENCIMENTO: '21/02/2022',
          NF_ENTRADA: '1001256714',
          SERIE: '123',
          EMITENTE: 'Indústria TASK Produtos',
          LOCAL_ESTOQUE: 'Almoxarifado'
        },
        {
          EMISSAO: '22/02/2022',
          VENCIMENTO: '22/02/2022',
          NF_ENTRADA: '1001256725',
          SERIE: '123',
          EMITENTE: 'Indústria TASK Produtos',
          LOCAL_ESTOQUE: 'Almoxarifado'
        }
      ],
      fields: [
        {
          key: 'EMISSAO',
          label: 'Emissão',
          sortable: true
        },
        {
          key: 'VENCIMENTO',
          label: 'Vencimento',
          sortable: true
        },
        {
          key: 'NF_ENTRADA',
          label: 'NF de Entrada',
          sortable: true
        },
        {
          key: 'SERIE',
          label: 'Série',
          sortable: true
        },
        {
          key: 'EMITENTE',
          label: 'Emitente',
          sortable: true
        },
        {
          key: 'LOCAL_ESTOQUE',
          label: 'Local de Estoque',
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock", route: "nfsentrada" },
      { title: "NF de Entrada" }
    ]);
  },
  computed: {
    ...mapGetters(["verificado", "fgModoPR"])
  },
  methods: {
    handleScroll() {

    }
  }
};
</script>
